const messages = {
    availPoints: "Pieejamie punkti",
    awaitingPoints: "Gaidošie punkti",
  board: {
    title: "Vadības panelis",
    title2: "Veiktspējas animācija {year}",
    headline1: "Jūsu akcijas un punkti vienā skatā",
    headline2: "Nopelniet punktus par riepu iegādi.",
    pointsBalanceToDate: "PUNKTU BILANCE UZ ŠODIENU",
    availPoints: "Pieejamie punkti",
    awaitingPoints: "Gaidošie punkti",
    yourRealisation: "JŪSU SASNIEGUMI",
    yourEngagement: "Jūsu ikgadējās saistības: <b>{tyres} riepas</b>",
    yourPoints: "JŪSU PUNKTI",
    yourRetailPurchase: "JŪSU MAZUMTIRDZNIECĪBAS PIRKUMI",
    yourRetailPurchaseCCS: "JŪSU MAZUMTIRDZNIECĪBA",
    pointsByPurchase: "jūsu pirkumu radītie punkti",
    pointsByBoosters: "pastiprinātāju radītie punkti",
    pointsByBSPurchase: "Punkti, kas iegūti no jūsu Bridgestone pirkumiem",
    pointsByBSPurchaseCCS:
      "Punkti, kas iegūti, pārdodot Bridgestone riepas",
    remaining: "Atlikušās riepas",
    yourGoal: "Vārtu progress",
    unit: "riepas",
    buttons: {
      learnMore: "Uzziniet vairāk par saviem punktiem",
      learnMoreAboutMechanism: "Uzziniet vairāk par mehāniku",
    },
    charts: {
      byBrand: "Pēc zīmola",
      bySize: "Pēc loka<br/>izmēra",
    },
    exploreResults: "Atklājiet savus rezultātus",
    tyreLimitInfo:
      "Katrā Booster kampaņas periodā ir nepieciešams vismaz 50 Bridgestone un/vai Firestone riepu izpārdošanas apjoms.",
  },
  charts: {
    byBrand: "Pēc zīmola",
    bySize: "pēc loka izmēra",
  },

  dashboard: {
    dashboardTitle: "Jūsu ieguvumi",
    dashboardBox: {
      title: "Punktu bilance",
      description: "Jūsu pašreizējie mārketinga punkti kopā",
      availPoints: "Pieejamie punkti",
      awaitingPoints: "Gaidošie punkti",
      lastUpdate: "Pēdējais atjauninājums",
      button: "Uzziniet vairāk",
      points: "points",
    },
  },
  soldTyres: "RIEPAS PĀRDOTAS",
  receivedPoints: "NOPELNĪTI PUNKTI",
  boosterCCS: {
    personalInfo: "Personiskā informācija",
    csNumberTitle: "Lūdzu, norādiet dalībnieka konta numuru(-us)",
    tyresTitle: "Lūdzu, norādiet pārdoto riepu skaitu",
    minTyresInfo:
      "Nepieciešamas vismaz {tyres} Bridgestone/Firestone riepas. Kompensācija attiecas tikai uz Bridgestone riepām.",
    tyresAmount: "Riepu skaits",
    filesTitle: "Lūdzu, augšupielādējiet pārdošanas apliecinājumu",
    filesDescription:
      "Lūdzu, ņemiet vērā: tiks ņemti vērā tikai tie pārdošanas apjomi, kuros norādīts riepu loka izmērs.",
    addAnotherFile: "Pievienojiet citu dokumentu",
    file: "Augšupielādējiet dokumentu",
    formatInfo:
      "Pieņemamie failu formāti: xlsx, jpeg un pdf. Maksimālais faila lielums: 8 MB",
    confrimationMessage:
      "<b>Paldies par dalību!</b> <br/>Jūsu pieprasījums ir saņemts un pārsūtīts Bridgestone komandām apstiprināšanai.<br/>Jūs saņemsiet e-pasta paziņojumu ar Booster CCS dalības rezultātiem.<br/>Uz drīzu tikšanos pakalpojumā Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Dalieties ar punktiem",
    forShare: "Punkti, kurus jūs dalīsit",
    title: "Nosaukums",
  },
  notFoundFile: "Nav atlasīts neviens",
  chooseFile: "Izvēlieties failu",
};
export default {
  messages,
};
